/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ConsoleInstanceListPurpose*`'s.
 */
export type ConsoleInstanceListPurpose = ConsoleInstanceListPurposeDashboard | ConsoleInstanceListPurposeProductPage;

/**
 * The purpose filter is for dashboard page.
 * @export
 */
export type ConsoleInstanceListPurposeDashboard = typeof CONSOLE_INSTANCE_LIST_PURPOSE_DASHBOARD;

/**
 * The purpose filter is for product page.
 * @export
 */
export type ConsoleInstanceListPurposeProductPage = typeof CONSOLE_INSTANCE_LIST_PURPOSE_PRODUCT_PAGE;

/**
 * The purpose filter value to get a list of instances for dashboard page.
 * @export
 */
export const CONSOLE_INSTANCE_LIST_PURPOSE_DASHBOARD = `dashboard`;

/**
 * The purpose filter value to get a list of instances for dashboard product page.
 * @export
 */
export const CONSOLE_INSTANCE_LIST_PURPOSE_PRODUCT_PAGE = `product`;
